<button
  mat-icon-button
  *ngIf="showActionsIcon; else showActiveButtons"
  [matMenuTriggerFor]="flightLogActions"
  (click)="onClick($event)"
>
  <mat-icon>more_vert</mat-icon>
</button>
<mat-menu #flightLogActions="matMenu">
  <ng-container *ngTemplateOutlet="showActiveButtons"></ng-container>
</mat-menu>

<ng-template #showActiveButtons>
  <ng-container *ngFor="let btn of activeButtons">
    <a *ngIf="btn.visible && btn.routerLink" mat-menu-item [routerLink]="btn.routerLink">
      <mat-icon *ngIf="btn.icon">{{ btn.icon }}</mat-icon>
      {{ btn.text }}
    </a>
    <button *ngIf="btn.visible && btn.click" mat-menu-item (click)="btn.click()">
      <mat-icon *ngIf="btn.icon">{{ btn.icon }}</mat-icon>
      {{ btn.text }}
    </button>
  </ng-container>
</ng-template>
